import {
    addCurrentVisit,
    deleteCurrentVisit,
    getCurrentVisitList,
    updateCurrentVisit
} from "@/services/modules/visit/visitService";
import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "@/state/alertHelpers";
import store from "@/state/store";
export const state = {
    currentVisitList: [],
    currentVisitSearchList: [],
    currentVisitListMetaData: [],
    salesPersonList: [],
    currentVisitListHeaders: [],
    currentVisitListLoading: false,
    currentVisitActionsList: [],
    noCurrentVisitMessage: "",
    selectedCurrentCode: "",
    selectedCurrentName: "",
}

export const mutations = {
    setNoCurrentVisitMessage(state,data) {
        state.noCurrentVisitMessage = data;
    },
    setCurrentVisitList(state,data) {
        state.currentVisitList = data;
    },
    setCurrentVisitListMetaData(state,data) {
        state.currentVisitListMetaData = data;
    },
    setCurrentVisitListHeaders(state,data) {
        state.currentVisitListHeaders = data;
    },
    setCurrentVisitListLoading(state,data) {
        state.currentVisitLoading = data;
    },
    setSelectedCurrentName(state, data) {
        state.selectedCurrentName = data;
    },
    setSelectedCurrentCode(state, data) {
        state.selectedCurrentCode = data;
    }
};

export const actions = {
    async fetchCurrentVisitList(context, {params,body}) {
        context.commit("setCurrentVisitListLoading",true)
        context.commit("setCurrentVisitListHeaders", [
            {
                key: "salesPersonCode",
                label: "Plasiyer Kodu",
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: "salesPersonName",
                label: "Plasiyer Adı",
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: "currentCode",
                label: "Cari Kodu",
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: "currentName",
                label: "Cari Adı",
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: "description",
                label: "Açıklama",
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: "visitDate",
                label: "Ziyaret Tarihi",
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: "duration",
                label: "Süre",
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key:"process",
                label: "İşlem",
                sortable: false,
                class: "text-center align-middle"
            }
        ])
        context.commit("setCurrentVisitList",[]);
        let result = await getCurrentVisitList(params,body)
        if (result && result.data && result.data.data) {
            context.commit("setSelectedCurrentName",result.data.data[0].currentName);
            result.data.data.forEach(item => {
                if (item.visitDate) {
                    item.visitDate = item.visitDate.split('T')[0];
                }
            });
        }
        context.commit("setCurrentVisitListLoading",false);
        context.commit("setCurrentVisitListMetaData", {
            totalCount: result.data.totalCount,
            totalPages:result.data.totalPages
        });
        if (result.data.success) {
            context.commit("setCurrentVisitList",result.data.data);
        } else {
            context.commit("setCurrentVisitList",[]);
            context.commit("setNoCurrentVisitMessage",result.data.message);
        }
        return result;
    },

    async fetchCurrentVisitSingle(context, {params,body}) {
        let result = await addCurrentVisit(params,body)
        if (result.data.success) {
            return result.data.data;
        } else
            return [];
    },

    async currentVisitAdd(context, {params,body}) {
        context;
        let result = await addCurrentVisit(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title:"İşlem Başarılı",
                text:result.data.message,
            })
        } else
            showProcessErrorMessage(({
                title: "İşlem Başarısız",
                text: result.data.message,
            }));
        return result;
    },
    async currentVisitUpdate(context, {params,body}) {
        let result = await updateCurrentVisit(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title:"İşlem Başarılı",
                text:result.data.message,
            })
        } else
            showProcessErrorMessage(({
                title: "İşlem Başarısız",
                text: result.data.message,
            }));
        return result;
    },
    async currentVisitDelete(context, {params,body,urlSegments}) {
        context;
        showProcessPromptMessage({
            title:"Cari Ziyareti Silinecek",
            text:"Cari ziyaretini Silmek istediğinize emin misiniz?"
        }).then(async function(confirm){
            if (confirm.isConfirmed){
                let result = await deleteCurrentVisit(params,body,urlSegments);
                if (result.data.success){
                    showProcessSuccessMessage({
                        title:"İşlem Başarılı",
                        text:result.data.message,
                    })
                    await context.dispatch("fetchCurrentVisitList",{
                            params: {
                                UserId: store.state.auth.user.UserId,
                                CurrentCode: state.selectedCurrentCode
                            },
                            body:{
                            }
                        }
                    )
                } else
                    showProcessErrorMessage(({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    }));
                return result;
            }
        })

    },
    setSelectedCurrentName(context,data) {
        context.commit("setSelectedCurrentName", data);
    },
    setSelectedCurrentCode (context,data) {
        context.commit("setSelectedCurrentCode", data);
    }
}